import React from "react";

type SpecItem = {
    label: string;
    // Value can be a string, number, or a pre-formatted React element (like a mapped list)
    value: string | number | React.ReactNode | null | undefined;
}

/**
 * Props for the SpecificationsBlock component.
 */
type Props = {
    title: string,
    items: SpecItem[],
}
export default function SpecificationsBlock({title, items}: Props) {
    // Filter out items where the value is null, undefined, or an empty string
    // (Optional: remove this filter if you want to show empty specs)
    const validItems = items.filter(item => item.value !== undefined && item.value !== null && item.value !== "");

    if (validItems.length === 0) return null;

    return (
        <div>
            <div className="border-b-2 border-blue-600 pb-1">
                <h2 className="text-2xl font-bold mb-4 uppercase">{title}</h2>
            </div>
            <div className="grid grid-cols-2 gap-y-2">
                {validItems.map((item, index) => (
                    <React.Fragment key={index}>
                        <span className="text-gray-600">{item.label}</span>
                        <span className="font-medium">{item.value}</span>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};